import { render, staticRenderFns } from "./CardAdminRegion.vue?vue&type=template&id=4ffd58fb"
import script from "./CardAdminRegion.vue?vue&type=script&lang=js"
export * from "./CardAdminRegion.vue?vue&type=script&lang=js"
import style0 from "./CardAdminRegion.vue?vue&type=style&index=0&id=4ffd58fb&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports